function triggerEcommerceEntryEvent(eventType, wrapperId, userType) {
  const wrapper = document.querySelector(`#${wrapperId}`);
  if (!wrapper) {
    return;
  }

  const event = new CustomEvent(eventType, {
    detail: {
      wrapperSelector: `#${wrapperId}`,
      userType,
    },
  });
  window.dispatchEvent(event);
}

// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する

export default triggerEcommerceEntryEvent;